module.exports = " <div> <ul class=\"nav nav-tabs\"> <li v-for=\"tab in config.tabs\" v-if=\"tab.show !== false\" :class=\"{ 'active': tab.id === active }\"> <a @click=activate(tab.id)> {{ tab.text || tab.id }} </a> </li> </ul> <div class=tab-content> <div class=tab-pane v-for=\"tab in config.tabs\" v-if=\"tab.show !== false\" :class=\"{ 'active': tab.id === active }\"> <slot :name=tab.id></slot> </div> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FTabs.vue
 ** module id = 223
 ** module chunks = 2
 **/